import('@/app');

export {};
